class Tracking {
    constructor ($element) {
        this.$element = $element;
        this.event = this.$element.getAttribute('data-tracking-event');
        this.type = this.$element.getAttribute('data-tracking-type');
        this.value = this.$element.getAttribute('data-tracking-value');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.type === 'click') {
            this.$element.addEventListener(this.type, () => {
                window.dataLayer = window.dataLayer || [];

                let timeout = 0;

                if (this.event === 'pageload') {
                    timeout = 1000;
                }

                if (this.event === 'bookmark') {
                    if (!this.$element.classList.contains('is--bookmarked')) {
                        console.log('name', 'tracking', this.value);
                        setTimeout(() => {
                            window.dataLayer.push({ // eslint-disable-line no-undef
                                event: 'add_bookmark',
                                event_name: 'add_bookmark',
                                add_bookmark: {
                                    product_bookmark: this.value
                                }
                            });
                        }, timeout);
                    }
                }

                setTimeout(() => {
                    window.dataLayer.push({ // eslint-disable-line no-undef
                        event: this.event
                    });
                }, timeout);
            });
        }
    }
}

export { Tracking };
